import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  list: { loading: false, data: null, error: null },
  kpi: { loading: false, data: null, error: null },
  promote: { loading: false, data: null, error: null },
};

export const marketingLeadSlice = createSlice({
  name: "marketingLead",
  initialState,
  reducers: {
    fetchMarketingLeadListRequest: (state) => {
      state.list.loading = true;
      state.list.error = null;
    },
    fetchMarketingLeadListSuccess: (state, action) => {
      state.list.data = action.payload;
      state.list.loading = false;
      state.list.error = null;
    },
    fetchMarketingLeadListFailure: (state, action) => {
      state.list.data = null;
      state.list.loading = false;
      state.list.error = action.payload;
    },
    fetchMarketingKpiRequest: (state) => {
      state.kpi.loading = true;
      state.kpi.error = null;
    },
    fetchMarketingKpiSuccess: (state, action) => {
      state.kpi.data = action.payload;
      state.kpi.loading = false;
      state.kpi.error = null;
    },
    fetchMarketingKpiFailure: (state, action) => {
      state.kpi.data = null;
      state.kpi.loading = false;
      state.kpi.error = action.payload;
    },
    promoteMarketingLeadRequest: (state) => {
      state.promote.loading = true;
      state.promote.error = null;
    },
    promoteMarketingLeadSuccess: (state, action) => {
      state.promote.data = action.payload;
      state.promote.loading = false;
      state.promote.error = null;
    },
    promoteMarketingLeadFailure: (state, action) => {
      state.promote.data = null;
      state.promote.loading = false;
      state.promote.error = action.payload;
    },
    resetPromoteState: (state) => {
      state.promote = initialState.promote;
    },
  },
});

export const {
  fetchMarketingLeadListRequest,
  fetchMarketingLeadListSuccess,
  fetchMarketingLeadListFailure,
  fetchMarketingKpiRequest,
  fetchMarketingKpiSuccess,
  fetchMarketingKpiFailure,
  promoteMarketingLeadRequest,
  promoteMarketingLeadSuccess,
  promoteMarketingLeadFailure,
  resetPromoteState,
} = marketingLeadSlice.actions;

export const getMarketingLeadListState = (state) => state.marketingLead.list;
export const getMarketingKpiState = (state) => state.marketingLead.kpi;
export const getMarketingPromoteState = (state) => state.marketingLead.promote;

export default marketingLeadSlice.reducer;
